import gql from "graphql-tag";
import { orderDetailsFragment } from "./fragments";

export const CREATE_ORDER = gql`
  ${orderDetailsFragment}
  mutation CreateOrder {
    createOrder(
      data: {
        maker: $maker
        taker: "0x23479a6877970E5889dfaD779e225aDC08eB8E03"
        start: "2022-07-20T17:30:15+05:30"
        end: "2022-07-20T17:30:15+05:30"
        hash: "hash1"
        salt: "1234"
        signature: "signature1"
        make: {
          type: { data: "assetTypeData1", nft: true, type: "assetTypeType1" }
          value: "makeValue1"
        }
        take: {
          type: { data: "assetTypeData1", nft: true, type: "assetTypeType1" }
          value: "takeValue1"
        }
        orderData: { isMakeFill: true, originFees: [], payouts: [] }
      }
    ) {
      ...OrderDetails
    }
  }
`;
